import { Chip as MuiChip } from '@mui/material';
import withClickTracking from './withClickTracking';

const Chip = withClickTracking(MuiChip);

export default Chip;
